"use client";

import React, { ReactNode } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from "./DropdownMenu";
import { cn } from "@/utils/cn";

export interface MenuItemType {
  key: string;
  label: ReactNode;
  icon?: ReactNode;
  disabled?: boolean;
  danger?: boolean;
  children?: MenuItemType[];
  onClick?: () => void;
  className?: string;
}

export interface DropdownV2Props {
  menu: {
    items: MenuItemType[];
    onClick?: (item: MenuItemType) => void;
  };
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  disabled?: boolean;
  children: ReactNode;
  className?: string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

const renderMenuItems = (
  items: MenuItemType[],
  parentOnClick?: (item: MenuItemType) => void,
) => {
  return items.map((item) => {
    const handleClick = () => {
      if (item.onClick) item.onClick();
      if (parentOnClick) parentOnClick(item);
    };

    if (item.children && item.children.length > 0) {
      return (
        <DropdownMenuSub key={item.key}>
          <DropdownMenuSubTrigger
            disabled={item.disabled}
            className={cn(item.className)}
          >
            {item.icon && <span className="mr-2 h-4 w-4">{item.icon}</span>}
            {item.label}
          </DropdownMenuSubTrigger>
          <DropdownMenuSubContent>
            {renderMenuItems(item.children, parentOnClick)}
          </DropdownMenuSubContent>
        </DropdownMenuSub>
      );
    }

    return (
      <DropdownMenuItem
        key={item.key}
        disabled={item.disabled}
        onClick={handleClick}
        className={cn(
          "cursor-pointer",
          item.danger && "text-red-500 focus:text-red-500 focus:bg-red-50",
          item.className,
        )}
      >
        {item.icon && <span className="mr-2 h-4 w-4">{item.icon}</span>}
        {item.label}
      </DropdownMenuItem>
    );
  });
};

export const DropdownV2: React.FC<DropdownV2Props> = ({
  menu,
  side,
  align,
  disabled,
  children,
  className,
  open,
  onOpenChange,
}) => {
  return (
    <DropdownMenu open={open} onOpenChange={onOpenChange}>
      <DropdownMenuTrigger
        disabled={disabled}
        className="cursor-pointer"
        asChild
      >
        {children}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        side={side as any}
        align={align as any}
        className={cn("min-w-[150px] z-[99999999999999999]", className)}
      >
        {renderMenuItems(menu.items, menu.onClick)}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
